import TableHeader from "./TableHeader";
import TableFooter from "./TableFooter";
import TableRow from "./TableRow";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "hooks/hooks";
import {
  getCarnetEmployees,
  selectEmployee,
  selectState,
  setInfoPopover,
  setPayrollPopover,
  setVacationPopover,
} from "../main.slice";
import { selectState as selectStateDashboard } from "Dashboard/dashboard.slice";
import {
  FormatDateIso,
  getFristDateOfCurrnetMonth,
  getLastDateOfCurrnetMonth,
} from "utils/dateUtils";
import Loader from "components/Loader/Loader";
import VacationPopover from "./VacationPopover";
import Popover from "components/Popover/Popover";
import InfoPopover from "./InfoPopover";
import { IProjectOption } from "Dashboard/domain/IProjectOption";
import PayrollPopover from "./PayrollPopover";

interface IProps {
  projects: IProjectOption[];
}

const TopSection = ({ projects }: IProps) => {
  const {
    loading,
    carnetEmployees,
    carnetsMap,
    carnetsDateMap,
    vacationPopover,
    infoPopover,
    payrollPopover } = useSelector(selectState);
  const selectedEmployee = useSelector(selectEmployee);
  const { provisions } = useSelector(selectStateDashboard);
  const dispatch = useAppDispatch();
  const hourlyRatesNotLoaded = !provisions?.activeHourlyRateNames;
  const hourlyRatesNotDefined = provisions?.activeHourlyRateNames
    && provisions.activeHourlyRateNames.length === 0;

  useEffect(() => {
    try {
      dispatch(
        getCarnetEmployees({
          carnetDataFrom: FormatDateIso(getFristDateOfCurrnetMonth()),
          carnetDataTo: FormatDateIso(getLastDateOfCurrnetMonth()),
        })
      );
    } catch (err) {
      console.log(err);
    }
  }, [dispatch]);

  return (
    <section className="loading-container">
      {loading || hourlyRatesNotLoaded || hourlyRatesNotDefined &&
        <Loader customMessage={hourlyRatesNotDefined
          ? "Nisu unete satnice u podešavanjima aplikacije"
          : undefined} />
      }
      <div className="g-grid g-header">
        <TableHeader />
      </div>
      <div className="g-grid g-content">
        {carnetEmployees &&
          carnetEmployees.map((carnetEmployee, index) => (
            <TableRow
              input={carnetsMap[carnetEmployee.employeeId]}
              dateInput={carnetsDateMap[carnetEmployee.employeeId]}
              carnetEmployee={carnetEmployee}
              options={projects}
              index={index}
              key={index}
            />
          ))}
      </div>

      <div className="g-grid g-footer">
        <TableFooter count={carnetEmployees.length} />
      </div>
      <Popover
        isOpen={vacationPopover.isOpen}
        onClose={() => {
          dispatch(setVacationPopover({ isOpen: false }));
        }}
        direction="right"
        title={`${selectedEmployee?.employeeName} - Unos odmora`}
        arrowStyle={{ top: "40%" }}
        position={{
          top: vacationPopover.top,
          left: vacationPopover.left,
          offsetLeft: 20,
          offsetTop: -80,
        }}
      >
        <VacationPopover />
      </Popover>
      <Popover
        isOpen={infoPopover.isOpen}
        position={{
          top: infoPopover.top,
          left: infoPopover.left,
          offsetLeft: infoPopover.offsetLeft,
          offsetTop: infoPopover.offsetTop,
        }}
        title={selectedEmployee?.employeeName ?? ""}
        direction="right"
        onClose={() =>
          dispatch(setInfoPopover({ isOpen: false, top: 0, left: 0 }))
        }
      >
        <InfoPopover />
      </Popover>
      <Popover
        isOpen={payrollPopover.isOpen}
        position={{
          top: payrollPopover.top,
          left: payrollPopover.left,
          offsetLeft: payrollPopover.offsetLeft,
          offsetTop: payrollPopover.offsetTop,
        }}
        title="Zarade"
        direction="right"
        onClose={() =>
          dispatch(setPayrollPopover({ isOpen: false, top: 0, left: 0 }))
        }
      >
        <PayrollPopover />
      </Popover>
    </section>
  );
};

export default TopSection;
